export const homeModule = {
  address: "주소",
  currentAddress: "현재 위치",
  position: "다시 위치 측정",
  positioning: "위치 추적 중",
  positionFail: "위치 추적 실패",
  addressList: "주소 목록",
  reposition: "위치 재조정",
  recommendStore: "가게 추천",
  sort1: "종합 정렬",
  sort2: "호평 우선",
  sort3: "일인당 낮은 것에서 높은 것",
  sort4: "일인당 높은 것에서 낮은 것",
  sort5: "배송비 최저치",
  filterDistance: "거리",
  filterSales: "판매량",
  filter: "선별",
  filterPrice: "일인당소비",
  devCondition: "배송조건",
  storeType: "요리 종류",
  manage: "관리",
  positionError: "위치 추적에 시간이 너무 오래 걸렸거나 실패했습니다. 수동으로 주소를 선택하십시오",
  changeText: "변경",
  noAddressTitle: "주소를 기준으로 가게를 검색하다",
  memberPrivilege: "회원의 특권",
  productCoupon: "저축 카드",
  appointment: "예약",
  lineUp: "줄을 서 서",
};
export const searchModule = {
  sort: "순서",
  addressPlace: "가게명을 입력하십시오",
  historySearch: "역사 기록",
  noData: "데이터가 없습니다"
};
